import React, { Component } from "react";
import { connect } from 'react-redux';
import { getOrdersWithStatus } from "redux/actions/report-actions";
import ReactValidator from "simple-react-validator";
import DatePicker from "react-datepicker";
import { Row, Col, Grid } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import 'react-table/react-table.css';
import ReactPlayer from 'react-player';
import { returnBoleanWithColumnMatch, BytesToMb } from 'helper/helperFunctions';
import Pagination from "../../ThemeComponents/Pagination";
const moment = window.moment;

class ReportTestingPage extends Component {
	constructor(props) {
		super(props);
		this.dateValidator = new ReactValidator();
		this.state = {
			fromDate: '',
			to: '',
			pageSize: 10,
			page: 0,
			sorted: '',
		}
	}
	DateChangeHandler = (value, field) => {
		this.setState({ [field]: value === null ? '' : moment(value).format("YYYY-MM-DD") }, () => {
			if (this.dateValidator.allValid()) {
				// const { fromDate, to, page, pageSize, sorted } = this.state;
				// this.props.getOrdersWithStatusCall('finalize_by_qa', 1, fromDate, to, page, pageSize, sorted);
				this.pagination.dataCall();
			} else {
				this.dateValidator.showMessages();
				this.forceUpdate();
			}
		})
	}
	dateElement(label, name, value, rules) {
		var selectedDate = this.state[name] !== '' ? new Date(this.state[name]) : '';
		const { fromDate, to } = this.state;
		return (
			<div className='form-group fullCalendar' id={name}>
				<label>{label}</label>
				<DatePicker className="form-control calender_icon" selected={selectedDate} name={name} onChange={(event) => this.DateChangeHandler(event, name)} />
				{
					(fromDate !== '' && to !== '') &&
					this.dateValidator.message(name, value, rules)
				}
			</div>
		);
	}
	orderWithStatusPaginationData = (page = this.state.page, sorted = this.state.sorted, pageSize = this.state.pageSize) => {
		const { fromDate, to } = this.state;
		this.props.getOrdersWithStatusCall('finalize_by_qa', 1, fromDate, to, page, pageSize, sorted);
	}
	paginationCall = (data) => {
		const { fromDate, to } = this.state;
		return this.props.getOrdersWithStatusCall('finalize_by_qa', 1, fromDate, to, data.page, data.pageSize, data.sort);
	}
	render() {
		const { to, fromDate } = this.state;
		// const { orderWithStatusData, OWSpages, loadingOrder } = this.props;
		const columns = [
			{
				Header: "Report Testing",
				headerClassName: 'headerPagination',
				columns: [
					{
						Header: "Barcode",
						accessor: "barcode",
                        width: 200,
						className: "action-center"
					},
					{
						Header: "Date Finished",
						accessor: "updated_at",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Group",
						accessor: "group_name",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Editor",
						accessor: "editor.name",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Produced By",
						accessor: "producer.name",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Quality Assurance",
						accessor: "qa.name",
						className: "action-center",
						sortable: false,
					},
					{
						Header: "Full Video",
						accessor: "order_resources",
						className: "action-center",
						Cell: ({ value }) => (
							<React.Fragment>
								{
									returnBoleanWithColumnMatch(value, 'resourceTypeSlug', 'full_video')
										?
										value.map(
											(prop, key) => {
												if (prop.resourceTypeSlug === 'full_video') {
													return (
														<React.Fragment key={key}>
															<ReactPlayer className='react-player' url={prop.file_path} controls={true} width={'200px'} height={'100px'} />
															<div>{BytesToMb(prop.file_size)} MB </div>
														</React.Fragment>
													);
												} else {
													return null;
												}
											}
										)
										:
										<span>Full video is not available</span>
								}
							</React.Fragment>
						),
						sortable: false,
					}
				]
			}
		];
		return (
			<div className="content">
				<Grid fluid>
					<Row>
						<Col md={12}>
							<Card
								ctTableResponsive
								content={
									<div>
										<Grid fluid>
											<div className="row">
												<Col md={4} >
													<div className='row flexElem flexResponsive align-items-center' >
														<div className="col-md-6" >
															{
																this.dateElement('Date From', 'fromDate', fromDate !== '' && moment(fromDate, 'YYYY-MM-DD'), [{ before: moment(this.state.to) }])
															}
														</div>
													</div>
												</Col>
												<Col md={4} >
													<div className='row flexElem flexResponsive align-items-center' >
														<div className="col-md-6" >
															{
																this.dateElement('Date To', 'to', to !== '' && moment(to, 'YYYY-MM-DD'), [{ after: moment(this.state.fromDate) }])
															}
														</div>

													</div>
												</Col>
												{/* <Col md={12} className="mt-md">
													<ReactTable
														noDataText='No destination found'
														data={orderWithStatusData}
														pages={OWSpages}
														columns={columns}
														defaultPageSize={10}
														loading={loadingOrder}
														className="-striped listing"
														loadingText={'Loading...'}
														pageData={this.orderWithStatusPaginationData}
														manual
														onFetchData={(state, instance) => {

															var sort = state.sorted.length === 0 ? '' : state.sorted[0].id + ',desc:' + state.sorted[0].desc;
															state.pageData(state.page + 1, sort, state.pageSize);
														}}
													/>
												</Col> */}
												<Pagination
													ref={(p) => this.pagination = p}
													showPagination={false}
													columns={columns}
													pageSize={10}
													noDataText='No destination found'
													getDataCall={this.paginationCall}
													filterView={false}
													// downloadData={true}
													// downloadFileName={'Orders'}
													// lowerContent = {null}
													// filterPlaceHolder = {'Orders'}
													getRowProps={this.getRowProps}
												// showAllToggle={true}
												/>
											</div>
										</Grid>
									</div>
								} />
						</Col>
					</Row>
				</Grid>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		getOrdersWithStatusCall: (status, value, fromDate, toDate, page, pageSize, sorted) => { return dispatch(getOrdersWithStatus(status, value, fromDate, toDate, page, pageSize, sorted)) },//example function
	});
};

function mapStateToProps(state) {
	const { orderWithStatusData, OWSpages, OWScurrent_page, OWStotal_orders, loadingOrder, ordersCountWithModerator } = state.reportReducer;
	return {
		orderWithStatusData, OWSpages, OWScurrent_page, OWStotal_orders, loadingOrder, ordersCountWithModerator
	};
}


const ReportTesting = connect(mapStateToProps, mapDispatchToProps)(ReportTestingPage);
export default ReportTesting;
